import { Component, computed, effect, inject, OnInit } from '@angular/core';
import { PageHeaderComponent } from '../../../components/shared/page-header/page-header.component';
import { PaaService } from '../paa.service';
import { Router } from '@angular/router';
import { getPaaHistoryDataTableStructure } from './utils/paa-history.data-table-object';
import { ButtonModule } from 'primeng/button';
import { DataTableRowActions, DynamicDataTable } from '../../../components/data-table-builder/data-table.types';
import { DataTableBuilderComponent } from '../../../components/data-table-builder/data-table-builder.component';
import { MessageService } from 'primeng/api';
import { Paa } from '@/types';
import { PaaRepository } from '../../../store/paa-state/paa-state.repository';
import { createServerQuery } from '@/components/data-table-builder/server-query';

@Component({
  selector: 'sm-paa-history',
  templateUrl: './history.component.html',
  styleUrl: './history.component.scss',
  imports: [PageHeaderComponent, DataTableBuilderComponent, ButtonModule],
})
export class PaaHistoryComponent implements OnInit {
  //services
  paaService = inject(PaaService);
  paaRepository = inject(PaaRepository);
  router = inject(Router);
  messageService = inject(MessageService);

  //breadcrumb
  breadcrumb = [
    {
      label: 'paa.pages.full_history',
      routerLink: ['/paa-history'],
    },
  ];

  //data-table
  serverQuery = createServerQuery({});
  queryParams = computed(() => ({
    page: this.serverQuery.page(),
    pageSize: this.serverQuery.pageSize(),
    sortBy: this.serverQuery.sortBy(),
    sortOrder: this.serverQuery.sortOrder(),
    search: this.serverQuery.search(),
  }));
  rowActions: DataTableRowActions = {
    defaultActions: {
      inspect: {
        label: 'paa.actions.inspect',
      },
    },
    inspectAction: (row: Paa) => {
      this.router.navigate([`paa-inspect-plan`, row.id]);
    },
  };

  loading = true;
  data: Paa[] = [];
  totalRecords = 0;
  datatableObject: DynamicDataTable = getPaaHistoryDataTableStructure({
    store: this.paaRepository,
    rowActions: this.rowActions,
    serverQuery: this.serverQuery,
  });

  constructor() {
    effect(() => {
      this.serverQuery.page();
      this.serverQuery.pageSize();
      this.serverQuery.search();
      this.serverQuery.sortBy();
      this.serverQuery.sortOrder();
      this.loadData();
    });
  }

  ngOnInit(): void {
    this.loadData();
  }

  redirectUpdatePaa() {
    this.router.navigate(['/paa-edit-plan']);
  }

  loadData() {
    this.paaService
      .getPaas({
        page: this.serverQuery.page(),
        size: this.serverQuery.pageSize(),
        sort: this.serverQuery.sortBy() ? `${this.serverQuery.sortBy()},${this.serverQuery.sortOrder()}` : '',
        search: this.serverQuery.search(),
      })
      .subscribe({
        next: data => {
          this.data = data.content;
          this.totalRecords = data.totalElements;
          this.loading = false;
        },
        error: err => {
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: err.error.message || 'Une erreur est survenue lors de la récupération des paas',
          });
        },
      });
  }
}
